import type * as api from '../api.ts';
import { Button, Finding } from '../ui.tsx';

/**
 * A building's boundary as a DRAWN OUTLINE instead of a circle (migration
 * 0140, Trav 2026-09-30) — the assembly-area pattern (0123) applied to the
 * building: "Draw the outline instead", map taps add corners, Finish needs
 * three, "Use a circle instead" goes back. Shared by the wizard's place step
 * and the building page so the words and the rules are one implementation.
 */
export function OutlineControls({
  ring,
  drawing,
  canStart,
  onStart,
  onFinish,
  onCancel,
  onUseCircle,
  pending = false,
  error = null,
}: {
  ring: api.LatLon[] | null;
  drawing: api.LatLon[] | null;
  /** A building with no pin has nowhere to draw around yet. */
  canStart: boolean;
  onStart: () => void;
  onFinish: () => void;
  onCancel: () => void;
  onUseCircle: () => void;
  pending?: boolean;
  error?: string | null;
}) {
  const refusal = error ? (
    <div className="mt-2 w-full max-w-[640px]">
      <Finding>{error}</Finding>
    </div>
  ) : null;
  if (drawing) {
    return (
      <div className="mt-3 max-w-[640px]">
        <p className="text-[14px] text-[var(--ink-2)]" role="status">
          Tap the map at each corner of the building — {drawing.length}{' '}
          {drawing.length === 1 ? 'corner' : 'corners'} so far.
          {drawing.length < 3 ? ' Three at least.' : ''}
        </p>
        <div className="mt-2 flex flex-wrap items-center gap-2">
          <Button variant="secondary" disabled={drawing.length < 3 || pending} onClick={onFinish}>
            {pending ? 'Saving…' : 'Finish outline'}
          </Button>
          <Button variant="quiet" onClick={onCancel}>
            Cancel
          </Button>
        </div>
        {refusal}
      </div>
    );
  }
  if (ring) {
    return (
      <div className="mt-3 flex max-w-[640px] flex-wrap items-center gap-2">
        <span className="text-[14px] text-[var(--ink-2)]">
          Outline drawn — {ring.length} corners.
        </span>
        <Button variant="quiet" disabled={pending} onClick={onStart}>
          Redraw
        </Button>
        <Button variant="quiet" disabled={pending} onClick={onUseCircle}>
          Use a circle instead
        </Button>
        {refusal}
      </div>
    );
  }
  return (
    <div className="mt-2">
      <Button variant="quiet" disabled={!canStart || pending} onClick={onStart}>
        Draw the outline instead
      </Button>
      {!canStart ? (
        <span className="ml-2 text-[13px] text-[var(--ink-2)]">Place the building first.</span>
      ) : null}
      {refusal}
    </div>
  );
}
